import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  TranslationFeedback,
  TranslationFeedbackTypeEnum,
} from '../../../../graphql/service/graphql-auto-main-service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { LotTranslationsFeedbackService } from '../../services/lot-translations-feedback.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { validateAllFormFields } from '../../../../../const';

@Component({
  selector: 'app-lot-translations-feedback-modal',
  templateUrl: './lot-translations-feedback-modal.component.html',
  styleUrls: ['./lot-translations-feedback-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotTranslationsFeedbackModalComponent implements OnInit {
  @Input() feedback: TranslationFeedback | null | undefined;
  @Input() type: TranslationFeedbackTypeEnum;
  @Input() translationId!: string;

  @Output() completed = new EventEmitter<void>();

  loading$: Observable<boolean>;

  readonly MAX_LENGTH = 350;

  form: FormGroup;

  TranslationFeedbackTypeEnum = TranslationFeedbackTypeEnum;

  constructor(
    private readonly modal: NzModalRef,
    private readonly fb: FormBuilder,
    private readonly lotTranslationsFeedbackService: LotTranslationsFeedbackService,
  ) {}

  ngOnInit(): void {
    const initialMessage =
      this.feedback?.message && this.feedback?.feedbackType === this.type
        ? this.feedback.message
        : '';

    this.form = this.fb.group({
      message: this.fb.control(initialMessage, [Validators.maxLength(this.MAX_LENGTH)]),
    });

    if (this.type === TranslationFeedbackTypeEnum.Dislike) {
      this.form.controls.message.addValidators([Validators.required, Validators.pattern(/.*\S.*/)]);
      this.form.controls.message.updateValueAndValidity({ emitEvent: false });
    }
  }

  createOrUpdateFeedback(): void {
    validateAllFormFields(this.form);

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const message = this.form.controls.message.value.trim();

    this.loading$ = this.buildFeedbackMutation$(message).pipe(
      finalize(() => {
        this.close();
        this.completed.emit();
      }),
    );
  }

  private buildFeedbackMutation$(message: string): Observable<boolean> {
    if (this.feedback) {
      return this.lotTranslationsFeedbackService.updateTranslationFeedback(
        this.feedback?.id,
        message,
        this.type,
      );
    }

    return this.lotTranslationsFeedbackService.createTranslationFeedback(
      this.translationId,
      message,
      this.type,
    );
  }

  close(): void {
    this.modal.destroy();
  }

  get dislikeType(): boolean {
    return this.type === TranslationFeedbackTypeEnum.Dislike;
  }

  get messagePlaceholder(): string {
    return this.dislikeType
      ? 'LOT_TRANSLATION_FEEDBACK.COMMENT_REQUIRED'
      : 'LOT_TRANSLATION_FEEDBACK.COMMENT_OPTIONAL';
  }
}
